import React from 'react'

interface IProps {
	titres: any
}

export const TitreGridView = ({ titres }: IProps) => {
	return (
		<>
			<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
				{titres.map((titre: any) => (
					<div
						className="container my-6 mx-auto px-2 md:px-5"
						key={titre.id}
					>
						<a href={titre.acf.url}>
							<article className="overflow-hidden rounded-lg shadow-lg h-44">
								<img
									alt="Placeholder"
									className="block h-auto w-full"
									src={titre.acf.logo}
								/>

								<header className="flex items-center justify-between leading-tight p-2 md:p-4">
									<h1 className="text-sm ">
										{titre.acf.titre}
									</h1>
									{/* <p className="text-grey-darker text-lg"> */}
									{/*	{titre.id} */}
									{/* </p> */}
								</header>
							</article>
						</a>
					</div>
				))}
			</div>
		</>
	)
}
